import { useRef, useState, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { Float, useTexture } from '@react-three/drei';
import * as THREE from 'three';
import { gsap } from 'gsap';
import logoImage from '../assets/logos/light/SCT.png';

function Logo() {
  const [aspectRatio, setAspectRatio] = useState(1);
  const [isHovered, setIsHovered] = useState(false);
  const materialRef = useRef<THREE.MeshBasicMaterial>(null);
  const texture = useTexture(logoImage, (loadedTexture) => {
    if (loadedTexture instanceof THREE.Texture) {
      const image = loadedTexture.image;
      setAspectRatio(image.width / image.height);
    }
  });

  const logoRef = useRef<THREE.Group>(null);
  
  useEffect(() => {
    if (materialRef.current) {
      gsap.to(materialRef.current, {
        opacity: isHovered ? 1 : 0.9,
        duration: 0.3,
      });
    }
  }, [isHovered]);

  useFrame(({ clock }) => {
    if (logoRef.current) {
      // Smooth rotation animation
      const time = clock.getElapsedTime();
      logoRef.current.rotation.y = Math.sin(time * 0.5) * 0.15;
      
      // Subtle floating effect
      const floatOffset = Math.sin(time * 2) * 0.02;
      logoRef.current.position.y = floatOffset;
      
      // Breathing scale effect
      const scale = 3 + Math.sin(time * 1.5) * 0.05;
      logoRef.current.scale.set(scale, scale, scale);
    }
  });

  return (
    <Float
      speed={2}
      rotationIntensity={0.2}
      floatIntensity={0.3}
    >
      <group 
        ref={logoRef}
        position={[0, 0, 0]}
        onPointerEnter={() => setIsHovered(true)}
        onPointerLeave={() => setIsHovered(false)}
      >
        <mesh>
          <planeGeometry args={[aspectRatio, 1]} />
          <meshBasicMaterial
            ref={materialRef}
            map={texture}
            transparent={true}
            side={THREE.DoubleSide}
            alphaTest={0.1}
            depthWrite={false}
            color="#ffffff"
            opacity={0.9}
          />
        </mesh>
      </group>
    </Float>
  );
}

export default function HeaderScene() {
  return (
    <>
      <ambientLight intensity={1} />
      <directionalLight
        position={[5, 5, 5]}
        intensity={1}
        castShadow
        shadow-mapSize={[1024, 1024]}
      />
      <group position={[0, 0, 0]}>
        <Logo />
      </group>
    </>
  );
}

